import bigHero from "../assets/images/hero-illustration-desktop.svg";
import smallHero from "../assets/images/hero-illustration-mobile.svg";
import { Link, useNavigate } from "react-router-dom";
import add from "../assets/icons/whiteAddCampaignIcon.svg";

const HeroSection = () => {

  const navigate = useNavigate();

  const saveCreateCampaignClick = () => {
    navigate("/sign-in", { state: { actionType: "createCampaign" } });
  };

    return ( 
      <div className="bg-brandGreen pt-20">
        <div className="bg-heroPattern pt-10 bg-contain md:bg-[length:28%] bg-repeat grid grid-cols-1 lg:grid-cols-5 items-end content-end transition-all duration-500">
          <div className="block md:hidden">
           <img src={smallHero} alt="" className="w-full h-full"/>
          </div>
          <div className="lg:col-span-2 px-4 md:px-12 pb-6 md:pb-16 text-white">
            <p className="text-pretty text-center md:text-start font-medium text-2xl md:text-[40px] leading-tight capitalize ubuntu-font">Your home for collective giving and receiving!</p>
            <p className="text-pretty text-center md:text-start mt-2 text-md md:text-md">Your contributions make a meaningful impact, and support is always available when you need it.</p>
            <div className="mt-8 grid grid-cols-1 md:grid-cols-5 gap-2">
            <div onClick={saveCreateCampaignClick} className="cursor-pointer text-sm font-medium py-6 px-8 rounded bg-black text-white w-full md:col-span-3 flex justify-center md:justify-between">
              <span>Create a campaign</span>
              <img src={add} alt="" className="hidden md:block"/> 
            </div>

            <Link to={"/all-campaigns"} className="text-sm font-medium py-6 px-8 md:p-4 rounded bg-white text-black w-full md:col-span-2 flex items-center justify-center">
              Make a donation
            </Link>
            </div>
          </div>
          <div className="lg:col-span-3 h-full">
           <img src={bigHero} alt="" className="w-full h-full hidden md:block ps-24"/>
          </div>
        </div>
      </div>
     );
}
 
export default HeroSection;